(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19528,61971,93812],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 61971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* eslint-disable react/destructuring-assignment */ 




var ScrollAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(45003), __webpack_require__.e(68741)]).then(__webpack_require__.bind(__webpack_require__, 68741));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68741)
            ];
        }
    }
});
var Reveal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8365).then(__webpack_require__.t.bind(__webpack_require__, 8365, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8365)
            ];
        }
    }
});
var Fade = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19470).then(__webpack_require__.t.bind(__webpack_require__, 19470, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19470)
            ];
        }
    }
});
var CSSAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 90959).then(__webpack_require__.bind(__webpack_require__, 90959)).then(function(module) {
        return module.CSSAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90959)
            ];
        }
    }
});
var ImageZoom = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 16626));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16626)
            ];
        }
    }
});
var Gsap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94744).then(__webpack_require__.bind(__webpack_require__, 94744)).then(function(module) {
        return module.Gsap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94744)
            ];
        }
    }
});
var ParallaxWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(11897)]).then(__webpack_require__.bind(__webpack_require__, 11897));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11897)
            ];
        }
    }
});
var ExpandWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68376).then(__webpack_require__.bind(__webpack_require__, 68376)).then(function(module) {
        return module.ExpandWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68376)
            ];
        }
    }
});
var CustomAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52612).then(__webpack_require__.bind(__webpack_require__, 52612)).then(function(module) {
        return module.CustomAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52612)
            ];
        }
    }
});
var JSONAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25845).then(__webpack_require__.bind(__webpack_require__, 25845)).then(function(module) {
        return module.JSONAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25845)
            ];
        }
    }
});
var Bounce = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94803).then(__webpack_require__.t.bind(__webpack_require__, 94803, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94803)
            ];
        }
    }
});
var CounterAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(78162)]).then(__webpack_require__.bind(__webpack_require__, 78162));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78162)
            ];
        }
    }
});
var ZoomOut = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(30730)]).then(__webpack_require__.bind(__webpack_require__, 30730));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30730)
            ];
        }
    }
});
var Animated = function(props) {
    switch(props.type){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isReveal */ .BK.isReveal:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reveal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isFade */ .BK.isFade:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCustom */ .BK.isCustom:
            {
                if (Object.keys(props).length === 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isJSON */ .BK.isJSON:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JSONAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isParallaxSpring */ .BK.isParallaxSpring:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParallaxWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageZoom, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.gsap */ .BK.gsap:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gsap, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.expandByHeight */ .BK.expandByHeight:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpandWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCSS */ .BK.isCSS:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CSSAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.bounce */ .BK.bounce:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bounce, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    })
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.counter */ .BK.counter:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CounterAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.zoomOut */ .BK.zoomOut:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomOut, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Animated);


/***/ }),

/***/ 25631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CaseStudiesIntro; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/containers/Animated/index.jsx
var Animated = __webpack_require__(61971);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesIntro/utils/helpers.js

var PAGE_WITH_TRANSPERENT_LOGO = (/* unused pure expression or super */ null && ([
    "stickerbox"
]));
var PAGE_WITH_TRANSPERENT_IMAGE = (/* unused pure expression or super */ null && ([
    "stickerbox"
]));
var PAGE_WITH_TRANSPERENT_IMAGE_BUNDLES = (/* unused pure expression or super */ null && ([]));
var SECTION_WITH_BACKGROUND_TITLE = {
    "open-sense": constants/* SVG_IMAGES_TYPES.opensenseTitleBorder */.NL.opensenseTitleBorder
};
var isAnimated = function(type) {
    return [
        constants/* CASE_STUDIES.carbonSpace */.qU.carbonSpace, 
    ].includes(type);
};

;// CONCATENATED MODULE: ./UI/sections/CaseStudiesIntro/utils/useCaseStudiesIntro.js








var useCaseStudiesIntro = function(param) {
    var type = param.type, introSection = param.introSection, data = param.data, breadcrumbs = param.breadcrumbs, breadcrumbsTheme = param.breadcrumbsTheme;
    var ref = (0,react.useState)(false), isMediaViewerOpen = ref[0], setIsMediaViewerOpen = ref[1];
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[0]", {}), [
        "title",
        "subtitle",
        "description",
        "images",
        "text",
        "imagesBundles",
        "contentModules",
        "contentList", 
    ]), title = ref1.title, subtitle = ref1.subtitle, description = ref1.description, images = ref1.images, introText = ref1.text, imagesBundles = ref1.imagesBundles, contentModules = ref1.contentModules, tagsList = ref1.contentList;
    var ref2 = function() {
        var imageAsMediaViewerPreviewTag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(tag) {
            return tag.includes("image-as-media-viewer-preview");
        });
        if (!imageAsMediaViewerPreviewTag) {
            return {};
        }
        var ref;
        var ref1 = (0,_sliced_to_array/* default */.Z)((ref = imageAsMediaViewerPreviewTag.split("=")) !== null && ref !== void 0 ? ref : [], 2), tagPayloadString = ref1[1];
        if (!tagPayloadString) {
            return {};
        }
        var tagPayload = JSON.parse(tagPayloadString);
        var ref2;
        var mediaIndex = (ref2 = tagPayload === null || tagPayload === void 0 ? void 0 : tagPayload.mediaIndex) !== null && ref2 !== void 0 ? ref2 : -1;
        var media = images === null || images === void 0 ? void 0 : images[mediaIndex];
        var mediaSimplified = {
            src: get_default()(media, "fields.file.url"),
            type: function() {
                var mediaType = get_default()(media, "fields.file.contentType");
                if (mediaType === null || mediaType === void 0 ? void 0 : mediaType.includes("video")) {
                    return "video";
                }
                return "image";
            }()
        };
        return {
            imageAsMediaViewerPreview: !!imageAsMediaViewerPreviewTag,
            mediaViewerAsset: media,
            mediaViewerAssetSimplified: mediaSimplified,
            mediaViewerAssetIndex: mediaIndex
        };
    }(), imageAsMediaViewerPreview = ref2.imageAsMediaViewerPreview, mediaViewerAsset = ref2.mediaViewerAsset, mediaViewerAssetSimplified = ref2.mediaViewerAssetSimplified, mediaViewerAssetIndex = ref2.mediaViewerAssetIndex;
    var contentList = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(module) {
        return (0,helper/* getDocumentFields */.OA)(module, [
            "title",
            "text"
        ]);
    });
    var ref3 = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[1]", {}), [
        "contentModules"
    ]), experiencesRaw = ref3.contentModules;
    var experiences = experiencesRaw === null || experiencesRaw === void 0 ? void 0 : experiencesRaw.map(function(experience) {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, experience), {
            image: (ref = get_default()((0,helper/* getDocumentFields */.OA)(experience, [
                "images"
            ]), "images")) === null || ref === void 0 ? void 0 : ref[0]
        });
    });
    var appLogoUrl = mediaViewerAssetIndex !== 1 ? (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(images, "[1]", "")), {
        fm: "png",
        fl: "png8"
    }) : undefined;
    var appLogoUrlSecond = mediaViewerAssetIndex !== 1 ? (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(images, "[2]", "")), {
        fm: "png",
        fl: "png8"
    }) : undefined;
    var backgroundImageUrl = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "images[0]", "")), {
        fm: "png"
    });
    var backgroundImageStyle = backgroundImageUrl ? {
        backgroundImage: "url(".concat(backgroundImageUrl, ")")
    } : {};
    var imageBackgroundTitle = (SECTION_WITH_BACKGROUND_TITLE === null || SECTION_WITH_BACKGROUND_TITLE === void 0 ? void 0 : SECTION_WITH_BACKGROUND_TITLE[type]) || null;
    var isAnimatedImg = isAnimated(type);
    var handleMediaViewerToggle = function() {
        if (!imageAsMediaViewerPreview) {
            return;
        }
        setIsMediaViewerOpen(function(prev) {
            return !prev;
        });
    };
    var isCaseStudy = Object.values(constants/* CASE_STUDIES */.qU).includes(type);
    return {
        type: type,
        backgroundImageStyle: backgroundImageStyle,
        introSection: introSection,
        experiences: experiences,
        appLogoUrl: appLogoUrl,
        appLogoUrlSecond: appLogoUrlSecond,
        appBackgroundImage: !!(images === null || images === void 0 ? void 0 : images[0]) && images[0],
        title: title,
        subtitle: subtitle,
        description: description,
        introText: introText,
        imagesBundles: imagesBundles,
        imageBackgroundTitle: imageBackgroundTitle,
        contentList: contentList,
        isAnimatedImg: isAnimatedImg,
        imageAsMediaViewerPreview: imageAsMediaViewerPreview,
        isMediaViewerOpen: isMediaViewerOpen,
        mediaViewerAsset: mediaViewerAsset,
        mediaViewerAssetSimplified: mediaViewerAssetSimplified,
        handleMediaViewerToggle: handleMediaViewerToggle,
        breadcrumbs: breadcrumbs,
        breadcrumbsTheme: breadcrumbsTheme,
        isCaseStudy: isCaseStudy
    };
};

// EXTERNAL MODULE: ./UI/sections/CaseStudiesIntro/styles.module.scss
var styles_module = __webpack_require__(58432);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/CaseStudiesIntro/index.jsx












var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var Media = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34190)
            ];
        }
    }
});
var MediaViewer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 15749).then(__webpack_require__.bind(__webpack_require__, 15749));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15749)
            ];
        }
    }
});
var CaseStudiesIntro = function(props) {
    var ref = useCaseStudiesIntro(props), type = ref.type, backgroundImageStyle = ref.backgroundImageStyle, introSection = ref.introSection, experiences = ref.experiences, appLogoUrl = ref.appLogoUrl, appLogoUrlSecond = ref.appLogoUrlSecond, appBackgroundImage = ref.appBackgroundImage, title = ref.title, subtitle = ref.subtitle, description = ref.description, introText = ref.introText, imagesBundles = ref.imagesBundles, imageBackgroundTitle = ref.imageBackgroundTitle, contentList = ref.contentList, isAnimatedImg = ref.isAnimatedImg, imageAsMediaViewerPreview = ref.imageAsMediaViewerPreview, isMediaViewerOpen = ref.isMediaViewerOpen, mediaViewerAssetSimplified = ref.mediaViewerAssetSimplified, handleMediaViewerToggle = ref.handleMediaViewerToggle, breadcrumbs = ref.breadcrumbs, breadcrumbsTheme = ref.breadcrumbsTheme, isCaseStudy = ref.isCaseStudy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: introSection,
        className: classnames_default()((styles_module_default())[type], (styles_module_default()).section),
        style: backgroundImageStyle,
        children: [
            isCaseStudy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                breadcrumbs: breadcrumbs,
                breadcrumbsStyles: (styles_module_default()).breadcrumbs,
                breadcrumbsTheme: breadcrumbsTheme
            }),
            mediaViewerAssetSimplified && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaViewer, {
                isOpen: isMediaViewerOpen,
                src: mediaViewerAssetSimplified.src,
                type: mediaViewerAssetSimplified.type,
                onClose: handleMediaViewerToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).introSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).contentWrapper,
                        children: [
                            appLogoUrl && appLogoUrlSecond ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).logoContainer,
                                children: [
                                    appLogoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).logoWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                            priority: true,
                                            transparent: true,
                                            className: (styles_module_default()).logo,
                                            src: appLogoUrl,
                                            alt: appLogoUrl
                                        })
                                    }),
                                    appLogoUrlSecond && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).logoWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                            priority: true,
                                            transparent: true,
                                            className: (styles_module_default()).logo,
                                            src: appLogoUrlSecond,
                                            alt: appLogoUrlSecond
                                        })
                                    })
                                ]
                            }) : appLogoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                priority: true,
                                transparent: true,
                                className: (styles_module_default()).logo,
                                src: appLogoUrl,
                                alt: appLogoUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                                title: title,
                                titleVariant: "h1",
                                subtitle: subtitle,
                                description: description,
                                className: (styles_module_default()).sectionTitle,
                                children: imageBackgroundTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                    type: imageBackgroundTitle,
                                    className: (styles_module_default()).titleBackground
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).introText,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                        document: introText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).introList,
                                        children: contentList === null || contentList === void 0 ? void 0 : contentList.map(function(param) {
                                            var itemTitle = param.title, text = param.text;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (styles_module_default()).listItem,
                                                children: [
                                                    itemTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: itemTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                                        document: text
                                                    })
                                                ]
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    appBackgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                            asset: appBackgroundImage,
                            className: classnames_default()((styles_module_default()).image, imageAsMediaViewerPreview && (styles_module_default()).clickable),
                            onClick: handleMediaViewerToggle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).bundleImagesContainer,
                        children: imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(image, index) {
                            return isAnimatedImg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated["default"], {
                                type: constants/* ANIMATED_TYPE.zoomOut */.BK.zoomOut,
                                className: classnames_default()((styles_module_default()).bundleAnimated, (styles_module_default())["bundleAnimated-".concat(index + 1)]),
                                delay: 200 * (index + 1),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                    priority: true,
                                    transparent: true,
                                    className: classnames_default()((styles_module_default()).bundleImage, (styles_module_default())["bundleImage-".concat(index + 1)]),
                                    asset: image
                                })
                            }, "intro-images-bundles/".concat(image.url)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                priority: true,
                                transparent: true,
                                className: classnames_default()((styles_module_default()).bundleImage, (styles_module_default())["bundleImage-".concat(index + 1)]),
                                asset: image
                            }, "intro-images-bundles/".concat(image.url));
                        })
                    })
                ]
            }),
            !!(experiences === null || experiences === void 0 ? void 0 : experiences.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).experiencesContainer,
                children: experiences === null || experiences === void 0 ? void 0 : experiences.map(function(param, index) {
                    var _fields = param.fields, experienceTitle = _fields.title, text = _fields.text, image = param.image;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).experience,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).infoTitle,
                                children: experienceTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                document: text
                            }),
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated["default"], {
                                type: constants/* ANIMATED_TYPE.zoomOut */.BK.zoomOut,
                                delay: 200 * (index + 1),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                    priority: true,
                                    transparent: true,
                                    asset: image
                                })
                            })
                        ]
                    }, experienceTitle);
                })
            })
        ]
    });
};
CaseStudiesIntro.propTypes = {
    type: (prop_types_default()).string.isRequired,
    introSection: prop_types_default().instanceOf(Object).isRequired,
    data: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var sections_CaseStudiesIntro = (CaseStudiesIntro);


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 58432:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section___8ZMV","sectionTitle":"styles_sectionTitle__b8MtM","contentWrapper":"styles_contentWrapper__u3B_V","logo":"styles_logo__oHmJR","appLink":"styles_appLink__Sd4aL","experiencesContainer":"styles_experiencesContainer__nmPVT","experience":"styles_experience__gLQr1","infoTitle":"styles_infoTitle__ImZW0","imageContainer":"styles_imageContainer__KSq2l","image":"styles_image__7BoDv","bundleImage":"styles_bundleImage__KPYGU","introSection":"styles_introSection__qdjF6","bundleImagesContainer":"styles_bundleImagesContainer__w0a98","breadcrumbs":"styles_breadcrumbs__YqCmj","stickerbox":"styles_stickerbox__lnqMK","fireaway":"styles_fireaway__hEXJU","fairy":"styles_fairy__m11zy","seven-pm-thursday":"styles_seven-pm-thursday__7oxE5","fernwayer":"styles_fernwayer__xiFFt","drive-focus":"styles_drive-focus__Yf6mY","hotel-data-cloud":"styles_hotel-data-cloud__eIJyw","open-sense":"styles_open-sense__fTmaX","titleBackground":"styles_titleBackground__ZHCRq","separate-us":"styles_separate-us__3y4E1","famlicious":"styles_famlicious__ZYAaR","natp":"styles_natp__Akxmi","cash-chat":"styles_cash-chat__K_idj","bundleImage-1":"styles_bundleImage-1__RWfjD","travel-trivia":"styles_travel-trivia__K_rvl","bundleImage-2":"styles_bundleImage-2__m_zgx","bundleImage-3":"styles_bundleImage-3__MTFHg","tell":"styles_tell__ryvFP","ubichat":"styles_ubichat__DOrLh","writer-chrome-extension":"styles_writer-chrome-extension__yIr7S","meateater":"styles_meateater__bFb7N","bionorica":"styles_bionorica__VqtkV","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__O_DTa","fusion-markets":"styles_fusion-markets__9wIF7","beautonomy":"styles_beautonomy__LgXLK","telemojo":"styles_telemojo__oeVPD","blackbird":"styles_blackbird__EA3sb","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__Sdybm","smartcenter":"styles_smartcenter__r3xNs","dindon":"styles_dindon__5rSkK","humankind":"styles_humankind__eWZSE","cinnabar":"styles_cinnabar__KmJzd","bundleImage-4":"styles_bundleImage-4__RxyQB","bundleImage-5":"styles_bundleImage-5__h6WVa","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__bvBlH","mobile-bank-application":"styles_mobile-bank-application__OQv_G","software-for-mri-interpretation":"styles_software-for-mri-interpretation__OO9HI","cedar-valley-farms":"styles_cedar-valley-farms__9VBFm","cedar-bounce":"styles_cedar-bounce__2iroz","mobile-budgeting-app":"styles_mobile-budgeting-app__v4iIy","forex-trading-platform":"styles_forex-trading-platform__Fk42E","introText":"styles_introText__qMNjL","why-us":"styles_why-us__7IKwi","crowdfunding-platform":"styles_crowdfunding-platform__c45ol","cctv-footage-analytics":"styles_cctv-footage-analytics__FcLKt","introList":"styles_introList__bACmZ","listItem":"styles_listItem__qpmeS","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__k4GTR","bundleAnimated":"styles_bundleAnimated__60Egf","bundleAnimated-1":"styles_bundleAnimated-1__vK7p_","bundleAnimated-2":"styles_bundleAnimated-2__QcRsj","bundleAnimated-3":"styles_bundleAnimated-3__3bUBy","web-p2p-lending-platform":"styles_web-p2p-lending-platform__0AIab","web-chat-for-mediums":"styles_web-chat-for-mediums__Q_Wtj","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__yNVC7","mobile-music-app":"styles_mobile-music-app__yIWZc","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__xD4MJ","digital-wallet-for-ios":"styles_digital-wallet-for-ios__jjhVm","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system___37ng","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__XDc99","restaurant-asset-management-tool":"styles_restaurant-asset-management-tool__sOq_U","custom-payment-gateway":"styles_custom-payment-gateway__WOewU","company":"styles_company__w0Fdg","ai-documentation-processing":"styles_ai-documentation-processing__s9vx8","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__dI1tG","ai-based-travel-planner":"styles_ai-based-travel-planner__P5m5m","ai-streamlined-recruitment-process":"styles_ai-streamlined-recruitment-process__2gPLi","writer-framework-platform":"styles_writer-framework-platform__dbypg","computer-vision-for-aras":"styles_computer-vision-for-aras__emmN5","clickable":"styles_clickable__He8jY","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__Hsefg","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__yBZDv","pen-testing-for-uk-web-dev-company":"styles_pen-testing-for-uk-web-dev-company__6IxKH","pen-tests-ai":"styles_pen-tests-ai__MBej3","web-logistics-platform":"styles_web-logistics-platform__P8BV2","logoContainer":"styles_logoContainer__ftAoA","logoWrapper":"styles_logoWrapper__NQej4","llm-legal-document-summarization":"styles_llm-legal-document-summarization__iB1G8","ai-feedback-analysis":"styles_ai-feedback-analysis__lq4qC","ai-for-edtech":"styles_ai-for-edtech__9OF2Y","ai-reporting-assistant":"styles_ai-reporting-assistant__Fu_Wf","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__PNPwP","feedback-insight-engine":"styles_feedback-insight-engine__6MgQx","predictive-ai-for-marketing":"styles_predictive-ai-for-marketing__ZXgP3","ai-agent-for-pre-screening":"styles_ai-agent-for-pre-screening__fSG8D","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__KGIme","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__6vV7w","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__TqCpo","ai-warehouse-agent":"styles_ai-warehouse-agent__BXaAh","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__gvLMx","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform__ygBGF","influx":"styles_influx__Pv_y1","futurepay":"styles_futurepay__d2lO3","commod":"styles_commod__3rqLi","blinking":"styles_blinking__0pdV4","swing":"styles_swing__Y7zF1","animateborder":"styles_animateborder__kOPNv","animateborder-overlay":"styles_animateborder-overlay__6UZ_x","animatecircle":"styles_animatecircle__WrzMs","animatedot":"styles_animatedot__f_jgi","animStar":"styles_animStar___qfeE","hideText":"styles_hideText__X8bRf","spin":"styles_spin__N48o_","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__NL7Mt","outOfTransparencyMobile":"styles_outOfTransparencyMobile__Sr_8x","appearance":"styles_appearance__EVyQ3","appearanceFromBelow":"styles_appearanceFromBelow__xgelh","flicker":"styles_flicker__E_4E1","vibrate1":"styles_vibrate1__P0e4l","rocket":"styles_rocket__2Js_j","burgerItem1":"styles_burgerItem1__GXshJ","burgerItem2":"styles_burgerItem2__wnM5S","burgerItem3":"styles_burgerItem3__pzmmz","burgerItem1Reverse":"styles_burgerItem1Reverse__g4ojL","burgerItem2Reverse":"styles_burgerItem2Reverse__WCWdX","burgerItem3Reverse":"styles_burgerItem3Reverse__AoSN_","arrow-down":"styles_arrow-down__GYmmk","image-scroll":"styles_image-scroll__kfwcP","image-scroll-reverse":"styles_image-scroll-reverse__QJ4no","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Qk6aL","hide-image":"styles_hide-image__BnUTI","stickerbox-pointer-second":"styles_stickerbox-pointer-second__L4vM7","stickerbox-pointer-third":"styles_stickerbox-pointer-third__RT3du"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);